import styled from 'styled-components';

import { CommonAction, recipesCommonAction, styledMedia } from '@pkg/primitives';

import { tokens } from './InfoAction.tokens';

export const StyledInfoAction = styled(CommonAction)`
    ${recipesCommonAction.basic};
    width: ${tokens.size}px;
    height: ${tokens.size}px;
    color: rgb(255, 255, 255, 0.4);

    &:focus,
    &:hover {
        color: rgb(255, 255, 255, 0.8);
    }

    &:active {
        color: rgb(255, 255, 255, 0.6);
    }
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.iconSize}px;
    height: ${tokens.iconSize}px;
`;
